import {LoaderHandler, TenantConfiguration} from "../../../core/domain/models";

export class SetTotalRecords {
  static readonly type = "[Base] Set Total Records For The Grid";

  constructor(public payload: number | undefined) {
  }
}

export class EnableLoading {
  static readonly type = "[Base] Enable Loading";
  constructor(public payload:  LoaderHandler | undefined) {
  }
}

export class DisableLoading {
  static readonly type = "[Base] Disable Loading";
  constructor(public payload:  LoaderHandler | undefined) {
  }
}

export class SetIsCreated {
  static readonly type = "[Base] Set Is Created";

  constructor(public payload: boolean | undefined) {
  }
}

export class SetIsUpdated {
  static readonly type = "[Base] Set Is Updated";

  constructor(public payload: boolean | undefined) {
  }
}

export class SetLocationId{
  static readonly type = "[Base] Set location id";

  constructor(public payload: string | undefined) {
  }
}
export class SetTenantConfigurations {
  static readonly type = "[Base] Set tenant configurations";

  constructor(public payload: TenantConfiguration[] | undefined) {
  }
}
export class SetIsDeleted {
  static readonly type = "[Base] Set Is Deleted";

  constructor(public payload: boolean | undefined) {
  }
}
